module.exports = __webpack_public_path__ + "images/autoleasegroningen_small871061c7221ec6383f99c81bb7c89c1c.png";